export default function initShapes() {
  const container = document.querySelector<HTMLElement>('.product-main-v2');

  if (!container) return;

  function update() {
    try {
      const params = new URLSearchParams(window.location.search);
      let forme = params.get('forme');
      if (!forme) forme = 'cœur';
      forme = decodeURIComponent(forme).toLowerCase().replace(/ /g, '-');

      const selector = '[data-forme="' + forme + '"]';
      const el = container!.querySelector<HTMLElement>(selector);
      const btns = container!.querySelectorAll<HTMLElement>('.regular-atc-btn');
      if (el) {
        el.classList.add('active');

        // Update label
        const label = container!.querySelector<HTMLElement>('.forme-label');
        if (label) label.innerText = forme.toUpperCase();

        // Handle sold out state immediately
        btns.forEach(function(btn) {
          const wrapper = btn.closest('.regular-atc-btn-wrapper');
          const targetToHide = wrapper || btn;
          const parent = btn.parentElement;
          let soldOutBtn = parent ? parent.querySelector('.product-form__atc-button-soldout') : null;
          
          // Fallback to container search if not found in parent
          if (!soldOutBtn) {
             soldOutBtn = container!.querySelector('.product-form__atc-button-soldout');
          }

          if (el!.classList.contains('not-available')) {
            if (targetToHide) targetToHide.classList.add('tw-hidden');
            if (soldOutBtn) soldOutBtn.classList.remove('tw-hidden');
          } else {
            if (targetToHide) targetToHide.classList.remove('tw-hidden');
            if (soldOutBtn) soldOutBtn.classList.add('tw-hidden');
          }
          
          // Update ATC button property
          btn.dataset.addtocartProp1 = JSON.stringify({ "Forme": forme.toUpperCase() });
        });
      }

      // Update linked products
      const linkedProducts = container!.querySelectorAll<HTMLElement>('.linked-product');
      linkedProducts.forEach(function (item) {
        const url = item.dataset.url;
        if (url) {
          item.addEventListener('click', function (e) {
            e.preventDefault();
            const separator = url.indexOf('?') > -1 ? '&' : '?';
            window.location.href = url + separator + 'forme=' + forme;
          });
        }
      });

      // Update images
      const imgs = container!.querySelectorAll<HTMLElement>('.composite-forme-image__img.forme__' + forme);
      imgs.forEach(function (img) {
        img.classList.remove('is-hidden');
      });
    } catch (e) {
      console.error(e);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update);
  } else {
    update();
  }
  document.addEventListener('product-template-update', update);
}
